import { EVENT_NAMES } from "./eventNames";

type EventTrackingConfig = {
  /** trueのとき、useTrackingContextStore の source をイベント名サフィックスに使用する */
  useSource?: boolean;
  /** trueのとき、useTrackingContextStore の pointsConsumed を props に含める */
  usePointsConsumed?: boolean;
};

/**
 * イベントごとのトラッキングコンテキスト使用設定。
 * ここに定義されたイベントのみ、useTrackingContextStore の値を参照する。
 * 参照後はストアが自動でクリアされる（単一消費）。
 */
export const EVENT_TRACKING_CONFIG: Partial<
  Record<string, EventTrackingConfig>
> = {
  [EVENT_NAMES.COMPLETE_SEND_GIFT]: {
    useSource: true,
    usePointsConsumed: true,
  },
  // さがす画面のLIVEカード経由で入室した場合のみ _FROM_DISCOVER サフィックスを追加送信する
  [EVENT_NAMES.WATCH_VIDEO_CHAT_AS_FIRST_VIEWER]: {
    useSource: true,
  },
  [EVENT_NAMES.WATCH_VIDEO_CHAT_AS_VIEWER]: {
    useSource: true,
  },
};
